import ActivationForm from './../model/form.model';

class FormController {
  constructor(ActivationApiService, StorageService, $timeout, $state, $translate) {
    'ngInject';

    this.ActivationApiService = ActivationApiService;
    this.StorageService = StorageService;
    this.$timeout = $timeout;
    this.$state = $state;
    this.$translate = $translate;
  }

  $onInit() {
    this.form = new ActivationForm();

    let activationForm = $('#activation-form');
    let formValidator = activationForm.parsley();

    activationForm.find('button').click(function() {
      formValidator.validate();
    });

    formValidator.on('form:success', function() {
    });
  }

  submitForm() {
    this.form.success = false;
    this.form.error = false;
    $('parsley-required').hide();
    if (!this.confirmTransactionPassword()) {
      this.form.error = true;
      this.form.errorMessage = this.$translate.instant('somethingWentWrong');

      return false;
    }

    this.form.activationCode = this.StorageService.getItem('activation_code');
    this.ActivationApiService.activate(this.form.toPayload())
    .then((response) => {
      this.form.success = true;
      this.form.error = false;
      this.StorageService.setItem('activation_code', '');
      this.form.successMessage = this.$translate.instant('activated');
      this.$timeout(() => {
        if (this.StorageService.getItem('customer_type') == 'AFF') {
          this.$state.go('marketing');
        } else {
          this.$state.go('dashboard');
        }
      }, 3000);
    })
    .catch((errors) => {
      $('.parsley-required').show();
      this.form.error = true;
      if (errors.message) {
        this.form.errorMessage = errors.message;
      } else {
        this.form.errorMessage = this.$translate.instant('somethingWentWrong');
        this.form.errorUsername = errors.children.username.children;
        this.form.errorPassword = errors.children.password.children;
      }
    })
    ;
  }

  resetForm() {
    $('.parsley-required').hide();
    this.form.error = false;
    this.form.username = '';
    this.form.confirmUsername = '';
    this.form.password = '';
    this.form.confirmPassword = '';
  }

  confirmTransactionPassword() {
    if (this.form.transactionPass === this.form.confirmTransPass) {
      return true;
    }
  }

  checkUsername() {
    this.ActivationApiService.validateUsername({ username: this.form.username })
    .then((response) => {
      $('#username').removeClass('parsley-error');
      this.form.errorUsernameExist = '';
    })
    .catch((errors) => {
      $('#username').addClass('parsley-error');
      this.form.errorUsernameExist = errors.message;
    })
    ;
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/activation/component/form.controller.js